import * as React from 'react';
import { JSSClassesProps } from 'react-jss';

import { ComponentJSSClasses } from './styles';

export interface SSRPlaceholderProps {}


interface StyledSSRPlaceholderProps extends JSSClassesProps<ComponentJSSClasses>, SSRPlaceholderProps {}


export function SSRPlaceholder(props: StyledSSRPlaceholderProps) {
    const { classes } = props;
    return <div className={classes.container} />;
}
